module.exports = __webpack_public_path__ + "img/wallet-two.365bf8f7.svg";